<template>
	<div class="container">
		<div class="top_title">
			<router-link class="icon_back" to="H050010" tag="span"></router-link>
			<p>{{info.I_TITLE_1}}</p>
		</div>
		<div class="scroll_area" style="overflow-y: auto">
			<div class="subjects" style="overflow-y: auto">
				<div class="score">
					<el-rate v-model="info.I_SCORE" disabled text-color="#ff9900" disabled-void-color="#ffffff">
					</el-rate>
				</div>
				<div class="row">
					<div>Quiz</div>
					<div>{{info.I_MSG}}</div>
				</div>
				<div v-for="item in info.dataList" class="subject">
					<p>{{item.I_QUESTION}}</p>
					<span class="I_QA_NO" style="display: none">{{item.I_QA_NO}}</span>
					<div class="options">
						<div style="margin: 0.5rem 0;" v-bind:class="[item.I_CHOICE_1_COLOR=='绿色' ? right : item.I_CHOICE_1_COLOR=='红色'? error: '']"><label><span
								 style="text-align: left;">{{item.I_CHOICE_1}}</span></label></div>
						<div style="margin: 0.5rem 0;" v-bind:class="[item.I_CHOICE_2_COLOR=='绿色' ? right : item.I_CHOICE_2_COLOR=='红色'? error: '']"><label><span>{{item.I_CHOICE_2}}</span></label></div>
						<div style="margin: 0.5rem 0;" v-bind:class="[item.I_CHOICE_3_COLOR=='绿色' ? right : item.I_CHOICE_3_COLOR=='红色'? error: '']"><label><span>{{item.I_CHOICE_3}}</span></label></div>
						<div style="margin: 0.5rem 0;" v-bind:class="[item.I_CHOICE_4_COLOR=='绿色' ? right : item.I_CHOICE_4_COLOR=='红色'? error: '']"><label><span>{{item.I_CHOICE_4}}</span></label></div>
					</div>
					<!-- <div v-if="item.I_ANSWER_USER == item.I_ANSWER" class="answer_area"><span>您的答案：</span><span class="right">{{item.I_ANSWER_USER}}</span></div> -->
					<!-- <div v-if="item.I_ANSWER_USER != item.I_ANSWER" class="answer_area"><span>您的答案：</span><span class="error">{{item.I_ANSWER_USER}}</span></div> -->
				</div>
			</div>
		</div>

		<router-link :to="{name: 'H050040', params: {id: this.info.I_BOOK_NO_SYS}}" class="submit_btn" tag="button">再做一遍</router-link>
		<!-- <router-link v-if="info.I_BUTTON_NAME_2==''" to="/H050010" class="submit_btn" tag="button">{{info.I_BUTTON_NAME_1}}</router-link> -->
	</div>
</template>

<script>
	import DataRequestFactory from '@/factories/dataRequestFactory.js'
	import Footer from '../components/Footer.vue'
	import weui from 'weui.js'

	export default {
		name: '',
		data() {
			return {
				nav: {
					sy: true,
					jchd: false,
					yyst: false,
					wd: false,
				},
				tabFlag: false,
				info: {
					dataList: []
				},
				right: 'right',
				error: 'error'
			}
		},
		components: {
			Footer
		},
		created() {
			this.info.I_BOOK_NO_SYS = this.$route.params.id
			if (this.info.I_BOOK_NO_SYS) {
				window.localStorage.setItem("H050050", this.info.I_BOOK_NO_SYS)
			} else {
				this.info.I_BOOK_NO_SYS = window.localStorage.getItem("H050050")
			}
			let params = {
				I_BOOK_NO_SYS: this.info.I_BOOK_NO_SYS
			}
			DataRequestFactory.I050044(params).then((response) => {
				this.info = response
			})
		},
		methods: {
			clickAnswer(e) {
				if (!$(e.currentTarget).hasClass('active')) {
					$(e.currentTarget).parent().find('label.active').removeClass("active")
					$(e.currentTarget).addClass('active')
				}
			}
		},
		mounted() {
			let screenHeight = window.innerHeight;
			let fontSize = getComputedStyle(window.document.documentElement)['font-size']
			let heightDiff = screenHeight - parseInt(fontSize) * 3.8
			$(".scroll_area").css("height", heightDiff + "px")
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	@import '../assets/css/pages/H050050.css';
	@import '../assets/css/common.css';
</style>



// WEBPACK FOOTER //
// src/pages/H050050.vue